import api from "./axios";

// Platform owner (super_admin) endpoints — manage firms, their yearly seat
// subscriptions, manual payments, and the addon catalog.
export const getOverview = () => api.get("/super/overview");

export const listFirms = (params = {}) => api.get("/super/firms", { params });
export const createFirm = (payload) => api.post("/super/firms", payload);
export const getFirm = (id) => api.get(`/super/firms/${id}`);
export const updateFirm = (id, payload) => api.put(`/super/firms/${id}`, payload);
export const getFirmStats = (id) => api.get(`/super/firms/${id}/stats`);
export const suspendFirm = (id) => api.post(`/super/firms/${id}/suspend`);
export const reactivateFirm = (id) => api.post(`/super/firms/${id}/reactivate`);
export const resetFirmAdminPassword = (firmId, userId) =>
  api.post(`/super/firms/${firmId}/admins/${userId}/reset-password`);
// Edit a firm admin's display name and/or login username.
export const updateFirmAdmin = (firmId, userId, payload) =>
  api.patch(`/super/firms/${firmId}/admins/${userId}`, payload);

// seats + renew=true starts a fresh yearly period; without renew it only
// adjusts the seat count mid-period.
export const updateFirmSubscription = (firmId, payload) =>
  api.put(`/super/firms/${firmId}/subscription`, payload);
export const recordFirmPayment = (firmId, payload) =>
  api.post(`/super/firms/${firmId}/subscription/payments`, payload);

export const listAddons = () => api.get("/super/addons");
export const updateAddon = (id, payload) => api.put(`/super/addons/${id}`, payload);
export const toggleFirmAddon = (firmId, addonId, payload) =>
  api.put(`/super/firms/${firmId}/addons/${addonId}`, payload);

// Platform server view: disk, runtime, all-firms drive, queue + failed jobs.
export const getSuperServer = () => api.get("/super/server");
export const retryFailedJobs = () => api.post("/super/server/retry-failed");
export const flushFailedJobs = () => api.post("/super/server/flush-failed");

// Platform-wide auth sessions (all firms) — list live devices + force-logout one.
export const listSessions = (params = {}) => api.get("/super/sessions", { params });
export const revokeSession = (id) => api.delete(`/super/sessions/${id}`);

// Users across all firms with their last request time + online state.
export const listActiveUsers = (params = {}) => api.get("/super/active-users", { params });
// A single user's rolling request history (newest first, capped server-side).
export const getUserRequests = (userId) => api.get(`/super/active-users/${userId}/requests`);
